import { useCallback } from 'react';

export const useSpeech = () => {
    const speak = useCallback((text, options = {}) => {
        if (!window.speechSynthesis) return;

        // Cancel current speech
        window.speechSynthesis.cancel();

        const theme = document.documentElement.getAttribute('data-theme');
        const isDark = theme === 'dark';

        const utterance = new SpeechSynthesisUtterance(text);

        // Bedtime friendly adjustments
        utterance.rate = options.rate || (isDark ? 0.75 : 0.9);
        utterance.pitch = isDark ? 1.0 : 1.1;
        utterance.volume = isDark ? 0.8 : 1.0;

        // Attempt to select a better voice
        const voices = window.speechSynthesis.getVoices();
        const preferredVoice = voices.find(v => v.name.includes('Samantha') || v.name.includes('Google US English'));
        if (preferredVoice) {
            utterance.voice = preferredVoice;
        }

        window.speechSynthesis.speak(utterance);
    }, []);

    const cancel = useCallback(() => {
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
        }
    }, []);

    return { speak, cancel };
};
